import { thumbsUp, getCaseDetail } from "@/http/case";
import { Prop, Vue, Component } from "vue-property-decorator";
import { CaseItem } from "@/interface/case";
import pdf from "vue-pdf";
@Component({
  components: {
    pdf
  }
})
export class DetailMixins extends Vue {
  @Prop() id!: string;
  public dataInfo: CaseItem | null = null;
  public loading = true;
  public previewPdf: any;
  public totalPage = 0;
  get baseUrl() {
    return window.StaticUrl;
  }
  get caseData() {
    return this.dataInfo || {};
  }
  handleLike(id: string) {
    if (this.dataInfo && this.dataInfo.thumbsUpStatus) {
      this.$message.info("您已经点过赞了!");
      return;
    }
    const user = sessionStorage.getItem("userInfo");
    if (user) {
      thumbsUp(id).then(res => {
        if (res.success) {
          this.$message.success("投票成功");
          this.getInfo();
        } else {
          this.$message.info(res.message);
        }
      });
    } else {
      this.$confirm("登录后即可参与评选！", "提示", {
        confirmButtonText: "登录",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => this.$router.push("/login"));
    }
  }
  async loadPdf() {
    const loading = this.$loading({
      lock: true,
      text: "加载中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    if (this.dataInfo) {
      this.previewPdf = pdf.createLoadingTask(
        `${this.baseUrl}/api/mr/pdf?url=${this.dataInfo.pdfUrl}`
      );
      if (this.previewPdf) {
        await this.previewPdf.promise
          .then((pdf: any) => {
            this.totalPage = pdf.numPages;
          })
          .catch((e: any) => this.$message.warning("pdf已损坏！"))
          .finally(() => loading.close());
      }
    }
  }
  getInfo() {
    this.loading = true;
    getCaseDetail(this.id).then(async (res: CaseItem) => {
      if (res.status) {
        this.dataInfo = res;
        await this.loadPdf();
      } else {
        this.$message.warning("当前案例不存在或被冻结！");
        this.$router.push(`/case`);
      }
    });
  }
}
